import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel from "@/__main__/data-model.mjs";
import { userModel } from "@/feature-auth/models/user-model.mjs";

export const model = {
  updateUser: userModel,
} satisfies ModelDefinition;

export type UpdateUserResponse = FromModel<typeof model>;

const UpdateUserResponseModel = createModel({
  data: model,
}).transform(model, (data) => data.data);

export default UpdateUserResponseModel;
